import AddIcon from "@mui/icons-material/Add";
import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useHotkeys } from "react-hotkeys-hook";
import Highlight from "components/ui/atoms/Highlight";
import {
  TopRightMenu,
  TopRightMenuItem,
} from "components/ui/molecules/TopRightMenu";
import { useContext } from "react";
import { UserContext } from "components/context/UserProvider";
import { useResetPeople } from "models/people/apiPeople";
import { useModal } from "@ebay/nice-modal-react";

const PeopleHeader = ({ people }) => {
  const theme = useTheme();
  const noteModal = useModal("NoteDrawer");
  const { user } = useContext(UserContext);
  const resetPeople = useResetPeople();

  const openCreateNote = () => {
    noteModal
      .show({
        formType: "create",
        initialValues: {
          owner: user.id,
          owner_detail: user,
          people_ids: [people.id],
          people: [people],
        },
      })
      .then(() => resetPeople(people.id));
  };

  useHotkeys("meta+j", () => openCreateNote, { preventDefault: true });

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={1}
      width={1}
    >
      <Highlight color={theme.palette_custom.yellow}>
        {people.best_name}
      </Highlight>
      <TopRightMenu style={{ marginLeft: "auto" }}>
        <TopRightMenuItem
          neverShow
          onClick={openCreateNote}
          endIcon={<AddIcon sx={{ scale: "0.8" }} />}
          title="&#8984;+j"
        >
          Note
        </TopRightMenuItem>
      </TopRightMenu>
    </Stack>
  );
};

export default PeopleHeader;
